/* ============================================
   ISLAND SUNRISE — SHOPIFY APP LOGIC
   Adapted from branding site with Shopify cart
   ============================================ */

const FREE_SHIPPING_THRESHOLD = 50;

// Product data (populated from Liquid in the section)
let islandProducts = window.ISLAND_PRODUCTS || [];
let islandCart = [];
let currentPairing = null;

// ============================================
// BLEND FINDER QUIZ
// ============================================
const quizQuestions = [
  {
    question: 'How do you like your roast?',
    options: [
      { label: 'Light & Bright', icon: 'sun', value: 'light' },
      { label: 'Smooth & Balanced', icon: 'coffee', value: 'medium' },
      { label: 'Bold & Dark', icon: 'flame', value: 'dark' }
    ]
  },
  {
    question: "What's your morning mood?",
    options: [
      { label: 'Energized & Ready', icon: 'zap', value: 'energetic' },
      { label: 'Calm & Reflective', icon: 'wind', value: 'calm' },
      { label: 'Slow & Easy', icon: 'feather', value: 'slow' }
    ]
  },
  {
    question: 'Which flavor calls to you?',
    options: [
      { label: 'Fruity & Floral', icon: 'flower', value: 'fruity' },
      { label: 'Sweet & Caramel', icon: 'heart', value: 'sweet' },
      { label: 'Rich & Chocolatey', icon: 'box', value: 'rich' }
    ]
  }
];

const quizResults = {
  'light-energetic-fruity': 'one-drop',
  'light-energetic-sweet': 'one-drop',
  'light-energetic-rich': 'caribbean-sunrise',
  'light-calm-fruity': 'one-drop',
  'light-calm-sweet': 'caribbean-sunrise',
  'light-calm-rich': 'caribbean-sunrise',
  'light-slow-fruity': 'one-drop',
  'light-slow-sweet': 'soft-beach',
  'light-slow-rich': 'caribbean-sunrise',
  'medium-energetic-fruity': 'caribbean-sunrise',
  'medium-energetic-sweet': 'caribbean-sunrise',
  'medium-energetic-rich': 'jamming-java',
  'medium-calm-fruity': 'soft-beach',
  'medium-calm-sweet': 'soft-beach',
  'medium-calm-rich': 'jamming-java',
  'medium-slow-fruity': 'soft-beach',
  'medium-slow-sweet': 'soft-beach',
  'medium-slow-rich': 'jamming-java',
  'dark-energetic-fruity': 'jamming-java',
  'dark-energetic-sweet': 'jamming-java',
  'dark-energetic-rich': 'blue-mountain',
  'dark-calm-fruity': 'jamming-java',
  'dark-calm-sweet': 'blue-mountain',
  'dark-calm-rich': 'blue-mountain',
  'dark-slow-fruity': 'jamming-java',
  'dark-slow-sweet': 'blue-mountain',
  'dark-slow-rich': 'blue-mountain'
};

let quizStep = 0;
let quizAnswers = [];

function renderQuiz() {
  const card = document.getElementById('blendFinderCard');
  if (!card) return;

  if (quizStep >= quizQuestions.length) {
    const resultKey = quizAnswers.join('-');
    const productId = quizResults[resultKey] || 'caribbean-sunrise';
    const product = islandProducts.find(p => p.handle === productId) || islandProducts[0];

    card.innerHTML = `
      <div class="blend-finder__result blend-finder__result--visible">
        <span class="blend-finder__result-label">Your perfect morning</span>
        <div class="blend-finder__result-image">
          <img src="${product.image}" alt="${product.name}">
        </div>
        <h3 class="blend-finder__result-name">${product.name}</h3>
        <p class="blend-finder__result-notes">${product.notes}</p>
        <button class="btn btn--primary" onclick="addToCart(${product.variantId}); closeQuizResult();">Add to Bag — $${product.price}</button>
        <button class="blend-finder__restart" onclick="restartQuiz()">Take it again</button>
      </div>
    `;
    return;
  }

  const q = quizQuestions[quizStep];
  let dots = '';
  for (let i = 0; i < quizQuestions.length; i++) {
    dots += `<span class="blend-finder__dot ${i === quizStep ? 'blend-finder__dot--active' : ''}"></span>`;
  }

  const iconSvg = (icon) => {
    const icons = {
      sun: '<circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>',
      coffee: '<path d="M18 8h1a4 4 0 010 8h-1"/><path d="M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/>',
      flame: '<path d="M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 11-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z"/>',
      zap: '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>',
      wind: '<path d="M9.59 4.59A2 2 0 1111 8H2m10.59 11.41A2 2 0 1014 16H2m15.73-8.27A2.5 2.5 0 1119.5 12H2"/>',
      feather: '<path d="M20.24 12.24a6 6 0 00-8.49-8.49L5 10.5V19h8.5z"/><line x1="16" y1="8" x2="2" y2="22"/><line x1="17.5" y1="15" x2="9" y2="15"/>',
      flower: '<circle cx="12" cy="12" r="3"/><path d="M12 2a3 3 0 013 3c0 1.5-1 2-1 2s2 .5 2 2-1 2-1 2 2 .5 2 2-1 2-1 2a3 3 0 01-3 3c-1.5 0-2-1-2-1s-.5 2-2 2-2-1-2-1-.5 2-2 2a3 3 0 01-3-3c0-1.5 1-2 1-2s-2-.5-2-2 1-2 1-2-2-.5-2-2a3 3 0 013-3c1.5 0 2 1 2 1s.5-2 2-2 2 1 2 1 .5-2 2-2z"/>',
      heart: '<path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>',
      box: '<path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>'
    };
    return `<svg class="blend-finder__option-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">${icons[icon] || icons.box}</svg>`;
  };

  card.innerHTML = `
    <div class="blend-finder__progress">${dots}</div>
    <h3 class="blend-finder__question">${q.question}</h3>
    <div class="blend-finder__options">
      ${q.options.map((opt, i) => `
        <button class="blend-finder__option" onclick="selectQuizAnswer('${opt.value}', ${i})">
          ${iconSvg(opt.icon)}
          <span class="blend-finder__option-label">${opt.label}</span>
        </button>
      `).join('')}
    </div>
  `;
}

function selectQuizAnswer(value, index) {
  const options = document.querySelectorAll('.blend-finder__option');
  options.forEach(o => o.classList.remove('blend-finder__option--selected'));
  if (options[index]) options[index].classList.add('blend-finder__option--selected');

  setTimeout(() => {
    quizAnswers.push(value);
    quizStep++;
    renderQuiz();
  }, 300);
}

function restartQuiz() {
  quizStep = 0;
  quizAnswers = [];
  renderQuiz();
}

function closeQuizResult() {}

// ============================================
// CART LOGIC (Shopify AJAX API)
// ============================================
async function addToCart(variantId, qty = 1) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (!res.ok) throw new Error('Failed to add to cart');
    await fetchCart();
    openCart();
  } catch (err) {
    console.error('Add to cart error:', err);
  }
}

async function fetchCart() {
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error('Failed to fetch cart');
    const data = await res.json();
    islandCart = data.items.map(item => {
      const product = islandProducts.find(p => p.variantId === item.variant_id || p.handle === item.handle);
      return {
        key: item.key,
        variantId: item.variant_id,
        handle: item.handle,
        name: item.title,
        price: (item.price / 100),
        qty: item.quantity,
        image: item.image || (product ? product.image : ''),
        roast: product ? product.roast : ''
      };
    });
    updateCartUI(data);
  } catch (err) {
    console.error('Fetch cart error:', err);
  }
}

async function changeQty(lineKey, delta) {
  const item = islandCart.find(i => i.key === lineKey);
  if (!item) return;
  const newQty = item.qty + delta;
  try {
    if (newQty <= 0) {
      await removeFromCart(lineKey);
    } else {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: newQty })
      });
      if (!res.ok) throw new Error('Failed to update cart');
      await fetchCart();
    }
  } catch (err) {
    console.error('Change qty error:', err);
  }
}

async function removeFromCart(lineKey) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
    if (!res.ok) throw new Error('Failed to remove from cart');
    await fetchCart();
  } catch (err) {
    console.error('Remove from cart error:', err);
  }
}

function getCartTotal() {
  return islandCart.reduce((sum, item) => sum + (item.price * item.qty), 0);
}

function getCartCount() {
  return islandCart.reduce((sum, item) => sum + item.qty, 0);
}

function getPairingSuggestion() {
  const cartHandles = islandCart.map(i => i.handle);
  const notInCart = islandProducts.filter(p => !cartHandles.includes(p.handle));
  if (notInCart.length === 0) return null;
  const marksPicks = notInCart.filter(p => p.marksPick);
  if (marksPicks.length > 0) return marksPicks[0];
  return notInCart[0];
}

function updateCartUI(cartData) {
  const countEl = document.getElementById('cartCount');
  const count = cartData ? cartData.item_count : getCartCount();
  if (countEl) {
    countEl.textContent = count;
    if (count > 0) {
      countEl.classList.remove('nav__cart-count--hidden');
    } else {
      countEl.classList.add('nav__cart-count--hidden');
    }
  }

  const itemsEl = document.getElementById('cartItems');
  const footerEl = document.getElementById('cartFooter');

  if (!itemsEl || !footerEl) return;

  if (islandCart.length === 0) {
    itemsEl.innerHTML = '<div class="cart__empty">Your bag is empty.<br>Time to find your blend.</div>';
    footerEl.style.display = 'none';
    return;
  }

  itemsEl.innerHTML = islandCart.map(item => `
    <div class="cart-item">
      <div style="width: 48px; height: 64px; border-radius: var(--radius-sm); overflow: hidden; flex-shrink: 0;">
        <img src="${item.image}" alt="${item.name}" style="width: 100%; height: 100%; object-fit: cover;">
      </div>
      <div class="cart-item__info">
        <span class="cart-item__name">${item.name}</span>
        ${item.roast ? `<span class="cart-item__roast">${item.roast}</span>` : ''}
        <div class="cart-item__bottom">
          <div class="cart-item__qty">
            <button class="cart-item__qty-btn" onclick="changeQty('${item.key}', -1)" aria-label="Decrease quantity">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="5" y1="12" x2="19" y2="12"/></svg>
            </button>
            <span class="cart-item__qty-num">${item.qty}</span>
            <button class="cart-item__qty-btn" onclick="changeQty('${item.key}', 1)" aria-label="Increase quantity">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            </button>
          </div>
          <span class="cart-item__price">$${(item.price * item.qty).toFixed(2)}</span>
        </div>
        <button class="cart-item__remove" onclick="removeFromCart('${item.key}')">Remove</button>
      </div>
    </div>
  `).join('');

  footerEl.style.display = 'flex';

  const total = cartData ? cartData.total_price / 100 : getCartTotal();
  const totalEl = document.getElementById('cartTotal');
  if (totalEl) totalEl.textContent = '$' + total.toFixed(2);

  // Shipping progress
  const shippingFill = document.getElementById('shippingFill');
  const shippingText = document.getElementById('shippingText');
  const shippingBar = document.getElementById('shippingBar');

  if (total >= FREE_SHIPPING_THRESHOLD) {
    if (shippingFill) shippingFill.style.width = '100%';
    if (shippingText) shippingText.textContent = "You've unlocked free shipping!";
    if (shippingBar) shippingBar.style.background = 'rgba(31,167,166,0.1)';
  } else {
    const remaining = (FREE_SHIPPING_THRESHOLD - total).toFixed(2);
    const progress = (total / FREE_SHIPPING_THRESHOLD) * 100;
    if (shippingFill) shippingFill.style.width = progress + '%';
    if (shippingText) shippingText.textContent = `You're $${remaining} away from free shipping`;
    if (shippingBar) shippingBar.style.background = 'rgba(200,154,60,0.08)';
  }

  // Pairing suggestion
  const pairingEl = document.getElementById('cartPairing');
  const pairing = getPairingSuggestion();
  if (pairing && islandCart.length < islandProducts.length) {
    currentPairing = pairing;
    if (pairingEl) {
      pairingEl.style.display = 'flex';
      const pImg = document.getElementById('pairingImage');
      const pName = document.getElementById('pairingName');
      if (pImg) pImg.src = pairing.image;
      if (pName) pName.textContent = pairing.name;
    }
  } else {
    currentPairing = null;
    if (pairingEl) pairingEl.style.display = 'none';
  }
}

function addPairing() {
  if (currentPairing) {
    addToCart(currentPairing.variantId);
  }
}

// ============================================
// CART DRAWER
// ============================================
function openCart() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  if (drawer) drawer.classList.add('cart--open');
  if (overlay) overlay.classList.add('cart-overlay--open');
  document.body.style.overflow = 'hidden';
}

function closeCart() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  if (drawer) drawer.classList.remove('cart--open');
  if (overlay) overlay.classList.remove('cart-overlay--open');
  document.body.style.overflow = '';
}

function checkout() {
  window.location.href = '/checkout';
}

// ============================================
// NAVIGATION
// ============================================
function toggleNav() {
  const navLinks = document.getElementById('navLinks');
  if (navLinks) navLinks.classList.toggle('nav__links--open');
}

function scrollToSection(id) {
  const navLinks = document.getElementById('navLinks');
  if (navLinks) navLinks.classList.remove('nav__links--open');
  const el = document.getElementById(id);
  if (el) {
    const offset = 72;
    const container = document.querySelector('.page-wrapper') || document.scrollingElement || document.body;
    const containerRect = container.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    const top = elRect.top - containerRect.top + container.scrollTop - offset;
    container.scrollTo({ top, behavior: 'smooth' });
  }
}

function scrollToTop() {
  const container = document.querySelector('.page-wrapper') || document.scrollingElement || document.body;
  container.scrollTo({ top: 0, behavior: 'smooth' });
}

// ============================================
// NEWSLETTER
// ============================================
function subscribeNewsletter(e) {
  e.preventDefault();
  const input = e.target.querySelector('input');
  const msg = document.getElementById('newsletterMsg');
  const email = input.value;

  if (email) {
    if (msg) msg.textContent = "Welcome to the family. We'll be in touch soon.";
    input.value = '';
    input.placeholder = 'Subscribed!';
  }
}

// ============================================
// NAV SCROLL EFFECT
// ============================================
window.addEventListener('scroll', () => {
  const nav = document.querySelector('.island-home .nav');
  const container = document.querySelector('.page-wrapper');
  const scrollY = container ? container.scrollTop : window.scrollY;
  if (nav) {
    if (scrollY > 100) {
      nav.style.background = 'rgba(11,31,58,0.98)';
    } else {
      nav.style.background = 'rgba(11,31,58,0.95)';
    }
  }
});

// Also listen on the scroll container
const scrollContainer = document.querySelector('.page-wrapper');
if (scrollContainer) {
  scrollContainer.addEventListener('scroll', () => {
    const nav = document.querySelector('.island-home .nav');
    const scrollY = scrollContainer.scrollTop;
    if (nav) {
      if (scrollY > 100) {
        nav.style.background = 'rgba(11,31,58,0.98)';
      } else {
        nav.style.background = 'rgba(11,31,58,0.95)';
      }
    }
  });
}

// ============================================
// SCROLL FADE-IN ANIMATIONS
// ============================================
function initScrollAnimations() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in--visible');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  document.querySelectorAll('.island-home .fade-in').forEach(el => observer.observe(el));
}

// ============================================
// INIT
// ============================================
document.addEventListener('DOMContentLoaded', () => {
  renderQuiz();
  initScrollAnimations();
  fetchCart();
});
